module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-autocomplete"
  }, [_c('vbl-input', _vm._b({
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput,
      "blur": _vm.onBlur
    }
  }, 'vbl-input', _vm.$attrs, false)), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "list"
  }, _vm._l((_vm.computedSuggestions), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.onClick(item[_vm.itemKey])
        }
      }
    }, [_vm._v("\n                " + _vm._s(item[_vm.itemKey]) + "\n            ")])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67b2e012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblAutocomplete/src/vblAutocomplete.vue
// module id = 273
// module chunks = 0